// extracted by mini-css-extract-plugin
export var active = "_95-c";
export var activeIndicator = "_95-7";
export var animate = "_95-b";
export var contentWidthTabs = "_95-5";
export var disabled = "_95-d";
export var flat = "_95-1";
export var fullWidth = "_95-3";
export var lg = "_95-a";
export var md = "_95-9";
export var redoButtonTabGroup = "_95-0";
export var sm = "_95-8";
export var tabButton = "_95-4";
export var tabButtonsContainer = "_95-2";
export var xs = "_95-6";